export default "__VITE_ASSET__1e295e90__"